<template>
  <g v-axis:props="props" :transform="transform" />
</template>

<script>
import { axisRight } from 'd3-axis';
import { AUTO, ELEMENTS } from './axes.constants';
import { axis } from './axes.directives';

const { RIGHT } = ELEMENTS;

export default {
  props: ['x', 'y', 'scale', 'setSpace', 'space', 'custom'],
  computed: {
    transform() {
      return `translate(${this.x}, ${this.y})`;
    },
    props() {
      return {
        axisScale: axisRight(this.scale),
        x: this.x,
        y: this.y,
        type: RIGHT,
        isAuto: this.space === AUTO,
        setSpace: this.setSpace,
      };
    },
  },
  directives: { axis },
};
</script>
